<template>
    <div class="is-primary-modal">
        <modal
            v-if="isShow"
            :confirm="true"
            :size="'is-small'"
            :title="'10DLC Compliance Registration'"
            :hide-submit="false"
            :submit-text="'Register for 10DLC'"
            :submitClasses="{
                'is-primary': true,
                'is-busy': isUpdating,
                'is-hidden': isMember || isManager,
            }"
            :cancelClasses="{ 'is-hidden': emptyTime }"
            :cancel-text="isMember || isManager ? 'Close' : 'Cancel'"
            :hideCloseIcon="emptyTime"
            :submitDisabled="isUpdating"
            class="ten-dlc__modal"
            @closed="closeModal"
            @submit="submit"
        >
            <div class="ten-dlc__content">
                <span class="ten-dlc__content__label"
                >Messaging from local numbers disabled in</span
                >
                <span class="ten-dlc__content__value"
                >{{ time.days_left || 0 }} day(s) {{ time.hours_left || 0 }} hour(s)</span
                >
            </div>
            <form-message type="is-danger" icon="info-circle">
                {{
                    isMember || isManager
                        ? 'Due to carrier compliance regulations in the US, please request your Admin to register your business for 10DLC. Learn more'
                        : 'Due to carrier compliance regulations in the US, you are required to register your business for 10DLC. Learn more'
                }}
                <a
                    class="link-blue-common"
                    href=" https://help.salesmessage.com/en/articles/6650461-changes-to-10dlc-sms-compliance-fall-2022"
                    target="_blank"
                >
                    here.
                </a>
            </form-message>
        </modal>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import ConversationsMixin from '../mixins/conversations';

export default {
    mixins: [ConversationsMixin],

    props: {
        type: { type: String, default: '' },
    },

    data() {
        return {
            isShow: false,
            isUpdating: false,
        };
    },

    computed: {
        ...mapState(stores.User, ['user', 'config']),

        isMember() {
            return (
                this.user.role === 'member' ||
                this.user.role === 'view_only' ||
                this.user.role === 'manager'
            );
        },

        isManager() {
            return this.user.role === 'manager';
        },

        time() {
            return this.config['10dlc_banners_info'].grace_period;
        },

        emptyTime() {
            return this.time.days_left === 0 && this.time.hours_left === 0;
        },

        isOldDesign() {
            return !this.hasFeatureUser('salesmsg-design-v2');
        },
    },

    methods: {
        init() {
            window.TenDLCBanner = this;

            if (window.localStorage.getItem('firstLogin') === 'true') {
                this.showModal();
                window.localStorage.setItem('firstLogin', 'false');
            }
        },

        clearGlobalTenDLCBannerTimer() {
            clearTimeout(window.globalTenDLCBannerTimer);
            window.globalTenDLCBannerTimer = null;
        },

        async showModal() {
            if (window.localStorage.getItem(`${this.user.id}_isShowTenDLCBanner`) === 'true') {
                this.isShow = true;
                this.clearGlobalTenDLCBannerTimer();
            }
        },

        async closeModal() {
            this.clearGlobalTenDLCBannerTimer();
            this.isUpdating = true;
            window.localStorage.setItem(
                `${this.user.id}_tenDLCBannerLastDate`,
                new Date().toISOString()
            );

            try {
                await this.$store.dispatch('updateTenDLCBannerDate');
                await this.$store.dispatch('getUserMe');
            } catch (e) {
                this.$log.error(e, {}, 'toggleTenDLCBanner');
            } finally {
                if (this.type !== 'widget' || (!this.emptyTime && this.type === 'widget')) {
                    this.isShow = false;
                }

                this.isUpdating = false;
            }
        },

        async submit() {
            this.clearGlobalTenDLCBannerTimer();
            this.isUpdating = true;
            window.localStorage.setItem(
                `${this.user.id}_tenDLCBannerLastDate`,
                new Date().toISOString()
            );

            try {
                await this.$store.dispatch('updateTenDLCBannerDate');
                await this.$store.dispatch('getUserMe');
            } catch (e) {
                this.$log.error(e, {}, 'toggleTenDLCBanner');
            } finally {
                this.isUpdating = false;
                if (this.type === 'widget') {
                    window.open('/settings/organization/compliance', '_blank');
                    if (!this.emptyTime) {
                        this.isShow = false;
                    }
                } else {
                    this.isShow = false;
                    this.$router.push('/settings/organization/compliance');
                }
            }
        },
    },

    mounted() {
        this.init();
    },
};
</script>
<style lang="scss">
.ten-dlc__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    &__label {
        font-weight: 400;
        font-size: 14px;
        color: #7f7f7f;
    }

    &__value {
        font-weight: 600;
        font-size: 18px;
        color: #363636;
    }

    @media (max-width: 658px) {
        flex-direction: column;
    }
}

.ten-dlc__modal {
    @media (max-width: 658px) {
        height: 100%;
        width: 100%;

        .modal {
            width: 100%;
            height: 100%;
            padding: 0;
            border-radius: 0;

            .modal-card {
                height: 100vh;
                max-height: unset;
                border-radius: 0;

                .modal-card-head {
                    border-radius: 0;

                    .delete {
                        display: none;
                    }
                }

                .modal-card-foot {
                    border-radius: 0;
                }
            }
        }
    }
}
</style>
